import { msg } from "../../../../locales/translate";
export const client_registration_form_step_2 = {
	model: {
		full_name: "",
		date_of_birth: "",
		citizenship: "",
		residential_address: "",

		id_type: "Select...",
		$__id_type_values: ["Passport", "Driver's License", "National ID"],

		id_number: "",

		politicaly_exposed_person: false,

		us_person: false,

		authorization_basis: "Select...",
		$__authorization_basis_values: ["Power of Attorney", "Statutes", "Board Resolution", "Other"],

		authorization_basis_other: "",
		$__authorization_basis_other_linked: "authorization_basis",
		$__authorization_basis_other_linked_value: "Other",

		phone_number: "",
		email_address: "",
	},
};

export const client_registration_form_step_2_decorator = {
	model: {
		get $__full_name_label() { return msg("fullName_f13a64ba"); },
		get $__date_of_birth_label() { return msg("dateOfBirth"); },
		$__date_of_birth_type: "date",
		get $__citizenship_label() { return msg("citizenship"); },
		$__citizenship_type: "country",
		get $__residential_address_label() { return msg("residentialAddressFullPhysicalAddressNotPOBox"); },
		get $__id_type_label() { return msg("idType"); },
		$__id_type_type: "select",
		get $__id_number_label() { return msg("idNumber"); },
		get $__politicaly_exposed_person_label() { return msg("politicallyExposedPersonPepStatus"); },
		get $__us_person_label() { return msg("uSPersonForFatcaSanctionsCheck"); },
		get $__authorization_basis_label() { return msg("basisForAuthorisation"); },
		$__authorization_basis_type: "select",
		authorization_basis_other: "",
		get $__authorization_basis_other_label() { return msg("specifyAuthorisationBasis"); },
		get $__phone_number_label() { return msg("phoneNumberForCommunication"); },
		get $__email_address_label() { return msg("emailAddressForCommunication"); },
	},

	$__model_decorator: {
		blockless: true,
		get subtitle() { return msg("theAuthorisedRepresentativeSignatoryIsRegardedAsThePersonWho_656a3c1b"); },
		sx: { gap: "20px" },

		blocks: [
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["full_name", "date_of_birth"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["citizenship", "residential_address"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["id_type", "id_number"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				order: ["politicaly_exposed_person", "us_person"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				sx: { alignItems: "end" },
				order: ["authorization_basis", "authorization_basis_other"],
			},
			{
				blockless: true,
				gridTemplateColumns: "1fr 1fr",
				sx: { alignItems: "end" },
				order: ["phone_number", "email_address"],
			},
		],
	},
};
